import { ChangeDetectionStrategy, Component } from '@angular/core';
@Component({
    selector: 'kh-dropdown-menu-item',
    templateUrl: './dropdown-menu-item.component.html',
    styleUrls: ['./dropdown-menu-item.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DropdownMenuItemComponent {
}
